const formComponentTranslations = {
  ActivityLevel: {
    level: "حدد مستوى نشاطك",
    sedentary: "كَسُول",
    light: "خفيف",
    moderate: "معتدل",
    active: "نشيط",
    veryActive: "نشيط جدا",
    trainingDays: "حدد أيام التدريب الخاصة بك",
    days0: "صفر ايام",
    days12: "يوم الي يومان",
    days3: "ثلاثة ايام",
    days4: "اربعة ايام",
    days5: "خمسة ايام",
    days6: "ستة ايام",
  },
  EquipmentCard: {
    chooseCardio: "اختر اجهزه الكارديو المتاحة",
    undo: "الرجوع",
    cardio: "كارديو",
    select: "اختر",
  },
  BodyFatQuestion: {
    title: "اختر طريقة قياس الدهون في جسمك",
    inBody: "In-Body",
    anotherDevice: "جهاز اخر",
    img: "اظهر لي صور مرجعية",
    percentage: "ادخل نسبة الدهون في جسمك",
    subTitle: `يرجى تقريب نسبة الدهون في الجسم على أساس
        صورة المرجعية.`,
    upload: "يرجى تحميل (in-Body) الخاص بك",
    uploadTitle: "تحميل صور ال(in-Body) الخاص بك",
  },
  foodItem: {
    title: "استبعاد الأطعمة التي لا تحبها",
    subtitle:
      "بما أنك تعاني من عدم تحمل اللاكتوز، فقد استبعدنا منتجات الألبان تلقائيًا من أجلك. لا تتردد في تعديل هذا الاختيار إذا رغبت.",
    categories: {
      protein: "مصادر البروتين",
      carbs: "الكربوهيدرات",
      fats: "مصادر الدهون",
      fruits: "الفاكهة",
      salad: "الخضروات",
    },
  },
  genderInfo: {
    age: "العمر",
    weight: "الوزن",
    height: "الطول",
    gender: "النوع",
    workoutTime: "وقت التمرين",
    male: "ذكر",
    female: "انثي",
    upload: "يرجى تحميل صورة جسدك",
    uploadTitle: "تحميل صورة جسدك من هنا",
  },
  Injuries: {
    injury: "اكتب إصابتك إذا كان لديك",
    exeCant: "اكتب التمارين التي لا يمكنك القيام بها",
    injuriesQuestion: {
      title: "هل لديك اي اصابة ؟",
      yes: "نعم",
      no: "لا",
    },
    injuriesFileUpload: {
      title: "برجاء ارفاق صورة الاشعة",
    },
  },
  mealsPerDay: {
    title: "عدد الوجبات في اليوم الواحد",
    meals2: "وجبتان + وجبة خفيفة",
    meal: "كيف ترد وجباتك ؟",
    meals3: "ثلاث وجبات + وجبة خفيفة",
    meals4: "اربع وجبات + وجبة خفيفة",
    lunch: "الإفطار والغداء",
    dinner: "الغداء والعشاء",
    lactose: "هل تعاني من مشاكل مع منتجات الالبان ؟",
    yesLactose: "نعم",
    noLactose: "لا",
    nutritionDiseases: {
      question: "نهل تعاني من اي امراض ؟",
      diseasesDescription: "اوصف المرض او الامراض التي تعاني منها",
      answers: {
        yes: "نعم",
        no: "لا",
      },
    },
  },
  nutritionPlanGoal: {
    title: "حدد هدف خطتك",
    extreme: "فقدان الدهون الشديد",
    fatLoss: "فقدان الدهون",
    reComposition: "إعادة التكوين",
    cleanBulking: "Clean Bulking",
    bulking: "Bulking",
    determine: "اختر لي",
    description: "صف هدفك بمزيد من التفاصيل",
    toolTips: {
      extFatLoss: "عايز اخس اكتر وزن في اسرع وقت",
      fatLoss:
        "عايز اخس دهون بالمعدل الطبيعي و الصحي و احاول اخلي خسارة العضلات قليلة",
      reComposition:
        "عايز وزني يبقي ثابت نوعا مااحاول انقص دهون قليلة و اثبت او ازيد عضل سنة",
      cleanBulking:
        "عايز ازود وزني شوية و تكون معظم الزيادة عضل و زيادة الدهون تكون في اقل الحدود",
      bulking:
        "عايز ازود وزني بشكل كبير و عايز ازود عضل و مش فارق معايا زيادة الدهون الي هتحصل",
      determineForMe:
        "انا مش عارف هدفي كويس (يتم تحديد الهدف من خلال رؤية الكوتش)",
    },
  },
  planPackage: {
    title: "اختر باقتك",
  },
  supplementsQuestion: {
    protein: "هل يتوفر لديك بروتين واي؟", //whey
    yesProtein: "نعم",
    noProtein: "لا",
    mass: "هل لديك مكملات ماس جينرة؟",
    yesMass: "نعم",
    noMass: "لا",
    upload: "يرجى تحميل حقائقك الغذائية عن ماس جينر", //mass gainer
    chooseSupplement: "اختر المكملات الغذائية التي لديك",
    choose: "اختر المكملات الغذائية",
    dontSeeSupplement: "ألا ترى المكمل الذي لديك؟",
    note: "ملاحظات المكملات الغذائية",
  },
  WeakestMuscleGroups: {
    title: "اختر أضعف العضلات لديك",
    chest: "صدر",
    back: "ظهر",
    legs: "رجل",
    abs: "عضلات البطن",
    biceps: "بايسيبس",
    triceps: "ترايسيبس",
    shoulders: "اكتاف",
    calves: "سمانة",
    iDontKnow: "الكوتش يختارلي",
  },
  workoutInitialQuestions: {
    train: "أين تريد التدريب؟",
    gym: "صالة رياضية",
    home: "المنزل",
    equipment: "اختر معدات الموجودة في منزلك",
    workout: "تكرار التمرين في الأسبوع",
    day2: "‏يومين",
    day3: "ثلاث ايام",
    day4: "اربع ايام",
    day5: "خمس ايام",
    day6: "ستة ايام",
    coach: "دع المدرب يقرر",
  },
  workoutProgramGoal: {
    goal: "ما هو هدفك من التمرين؟",
    building: "بناء العضلات",
    strength: "قوة العضلات",
    endurance: "التحمل العضلي",
    shredding: "تمزيق",
    dontKnowGoal: "لا أعرف هدفي",
    train: "كم من الوقت تدربت ؟",
    month0: "لم أتدرب من قبل",
    month16: "مبتدئ (لدي خبرة قليلة في التمرين في الجيم )",
    month612: "متوسط",
    month12: "متقدم",
  },
  generalComments: {
    title: "هل لديك اي معلومات اضافية تود ان تخبرنا بها عن يومك ؟",
    textFieldLabel: "التفاصيل",
  },
};

export default formComponentTranslations;
